<template>
    <div class="menuAdmin">
        <div class="menuCont">
            <my-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="false"
                :treeToolBar="treeToolBar"
                :defaultProps="defaultProps"
                :nodeKey="'id'"
                @handleAddTreeNode="handleAddTreeNode"
                @handleTreeNodeClick="handleTreeNodeClick"
                :default-expand-all="false"
                :defaultExpandedKeys="[0]"
                :defaultExpandAll="true"
                :btnName="btnName"
                :treeSearchBar="false"
            >
            </my-tree>
        </div>
        <div class="formCont">
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="100px"
                :inline="true"
            >
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item
                            label="菜单名称"
                            :rules="[
                                { required: true, message: '请输入菜单名称' }
                            ]"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入菜单名称"
                                maxlength="20"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="上级菜单" v-if="this.level > -1">
                            <span
                                style="font-size:13px;position:relative;top:-1px"
                                >{{
                                    this.addForm.parent_name
                                        ? this.addForm.parent_name
                                        : ""
                                }}</span
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="URL">
                            <el-input
                                clearable
                                placeholder="请输入URL"
                                maxlength="50"
                                size="small"
                                v-model="addForm.url"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="图标ICON"
                            v-if="this.level == 0 || this.level == 2"
                        >
                            <el-input
                                clearable
                                placeholder="请输入图标ICON"
                                maxlength="50"
                                size="small"
                                v-model="addForm.icon"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="this.level > 1">
                        <el-form-item label="按钮位置">
                            <el-radio v-model="addForm.type" :label="'table'"
                                >Table</el-radio
                            >
                            <el-radio v-model="addForm.type" :label="'action'"
                                >Action</el-radio
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="this.level > 1">
                        <el-form-item label="按钮功能类型">
                            <el-radio v-model="addForm.status_flag" :label="1"
                                >常规按钮</el-radio
                            >
                            <el-radio v-model="addForm.status_flag" :label="2"
                                >状态按钮（有原因）</el-radio
                            >
                            <el-radio v-model="addForm.status_flag" :label="3"
                                >状态按钮（无原因）</el-radio
                            >
                            <el-radio
                                v-show="addForm.type == 'table'"
                                v-model="addForm.status_flag"
                                :label="4"
                                >气泡确认框</el-radio
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="主题类名"
                            v-if="addForm.type == 'action'"
                        >
                            <el-input
                                clearable
                                placeholder="请输入主题类名"
                                maxlength="20"
                                size="small"
                                v-model="addForm.class"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="函数名称" v-if="this.level > 0">
                            <el-input
                                clearable
                                placeholder="请输入函数名称"
                                maxlength="50"
                                size="small"
                                v-model="addForm.funcName"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="排序">
                            <el-input
                                clearable
                                placeholder="请输入排序"
                                maxlength="50"
                                size="small"
                                v-model="addForm.sort"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="模块状态" v-if="this.level >= 2">
                            <el-checkbox-group v-model="show_button">
                                <el-checkbox
                                    v-for="(item, index) in this
                                        .menuSelectStatusList"
                                    :key="index"
                                    :label="item.value"
                                    @change="checkboxChange"
                                    >{{ item.name }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="状态编辑" v-if="this.level == 1">
                            <el-row
                                :gutter="0"
                                v-for="(item, index) in menuGetStatusList"
                                :key="index"
                            >
                                <el-col :span="6">
                                    <el-input
                                        size="small"
                                        placeholder="状态名"
                                        v-model="item.name"
                                    ></el-input>
                                </el-col>
                                <el-col :span="6" :offset="1">
                                    <el-input
                                        size="small"
                                        type="number"
                                        placeholder="状态值"
                                        v-model="item.value"
                                    ></el-input>
                                </el-col>
                                <el-col :span="6" :offset="1">
                                    <el-input
                                        size="small"
                                        type="number"
                                        placeholder="排序"
                                        v-model="item.sort"
                                    ></el-input>
                                </el-col>
                                <el-col :span="3" :offset="1">
                                    <el-button
                                        type="text"
                                        size="mini"
                                        icon="el-icon-plus"
                                        @click="addItems"
                                    ></el-button>
                                    <el-button
                                        type="text"
                                        size="mini"
                                        icon="el-icon-minus"
                                        @click="minusItems(index)"
                                    ></el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="footer">
                <el-button @click="commit" type="primary" size="small"
                    >保 存</el-button
                >
                <el-button @click="clear" v-if="nowStatus" size="small"
                    >清 空</el-button
                >
                <el-button @click="del" type="danger" v-else size="small"
                    >删 除</el-button
                >
            </div>
        </div>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi";
import Tree from "@/comon/components/treeChange";

export default {
    data() {
        return {
            treeData: [],
            treeLoading: false,
            treeToolBar: true,
            defaultProps: {
                children: "child",
                label: "name"
            },
            btnName: "创建菜单",

            addForm: {
                name: "",
                parent_name: "",
                url: "",
                icon: "",
                type: "",
                funcName: "",
                sort: "",
                class: "",
                status_flag: 0
            },
            show_button: [],
            parent_id: -1,
            nowStatus: false,
            level: 0,
            menuSelectStatusList: [],
            menuGetStatusList: [],
            emptyItem: {
                name: "",
                value: "",
                sort: ""
            },
            now_id: ""
        };
    },
    methods: {
        getMenu(id) {
            this.treeLoading = true;
            oaApi.menu({}, "get", id).then(res => {
                if (res) {
                    if (id) {
                        this.addForm = res.data;
                        this.show_button = res.data.show_button
                            ? res.data.show_button
                            : [];
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(id);
                        });
                    } else {
                        this.treeData = res.data;
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id ? this.addForm.id : 0
                            );
                        });
                    }
                }
                this.treeLoading = false;
            });
        },
        handleAddTreeNode() {
            let lastForm = {};
            lastForm = JSON.parse(JSON.stringify(this.addForm));
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm.name = "";
            this.addForm.parent_name = lastForm.name;
            this.addForm.parent_id = lastForm.id;
            this.addForm.id = "";
            this.addForm.url = "";
            this.addForm.icon = "";
            this.addForm.type = "";
            this.addForm.funcName = "";
            this.addForm.sort = "";
            this.addForm.status_flag = 0;
            this.nowStatus = true;
            this.level = Number(this.level + 1);
            //   this.$nextTick(() => {
            // this.$refs.myTree.$refs.tree.setCurrentKey();
            //   });
        },
        clear() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm.name = "";
            this.addForm.url = "";
            this.addForm.icon = "";
            this.addForm.type = "";
            this.addForm.funcName = "";
            this.addForm.sort = "";
            this.addForm.status_flag = 0;
        },
        handleTreeNodeClick(item) {
            this.now_id = item.id;
            this.level = item.level;
            this.parent_id = item.parent_id;
            this.nowStatus = false;
            this.menuSelectStatusList = [];
            this.menuGetStatusList = [];
            this.show_button = [];
            this.getMenu(item.id == 0 ? 999999 : item.id);
            if (item.level >= 2) {
                this.menuSelectStatus();
            } else if (item.level == 1) {
                this.menuGetStatus();
            }
        },
        commit() {
            this.treeLoading = true;
            if (this.level == 1) {
                this.menuSetStatus();
            }
            oaApi
                .menu(
                    {
                        ...this.addForm,
                        show_button: this.show_button
                    },
                    this.addForm.id ? "put" : "post",
                    this.addForm.id
                )
                .then(res => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success("保存成功");
                            this.getMenu();
                            this.getMenu(res.data.id);
                            this.$store.dispatch("getMenuListByRoles");
                        }
                    }
                    this.treeLoading = false;
                });
        },
        menuSetStatus() {
            oaApi.menuSetStatus(
                {
                    menu_id: this.now_id,
                    dataInfo: this.menuGetStatusList
                },
                "post"
            );
        },
        del() {
            this.$confirm("确认删除此菜单？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.treeLoading = true;
                    oaApi.menu({}, "delete", this.addForm.id).then(res => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success("删除成功");
                            }
                            this.treeLoading = false;
                            this.getMenu();
                            this.getMenu(999999);
                            this.$store.dispatch("getMenuListByRoles");
                        }
                    });
                })
                .catch(() => {
                    this.$message.info("未删除");
                });
        },
        menuSelectStatus() {
            oaApi
                .menuSelectStatus(
                    {
                        menu_id: this.parent_id
                    },
                    "get"
                )
                .then(res => {
                    if (res) {
                        this.menuSelectStatusList = res.data;
                    }
                });
        },
        menuGetStatus() {
            oaApi
                .menuGetStatus(
                    {
                        menu_id: this.now_id
                    },
                    "get"
                )
                .then(res => {
                    if (res) {
                        this.menuGetStatusList = res.data.dataInfo
                            ? res.data.dataInfo
                            : [];
                        if (
                            this.menuGetStatusList &&
                            this.menuGetStatusList.length == 0
                        ) {
                            this.menuGetStatusList.push(
                                JSON.parse(JSON.stringify(this.emptyItem))
                            );
                        }
                    }
                });
        },
        addItems() {
            this.menuGetStatusList.push(
                JSON.parse(JSON.stringify(this.emptyItem))
            );
        },
        minusItems(index) {
            if (this.menuGetStatusList && this.menuGetStatusList.length > 1) {
                this.menuGetStatusList.splice(index, 1);
            }
        }
    },

    created() {
        this.getMenu();
        this.getMenu(999999);
    },
    components: {
        "my-tree": Tree
    }
};
</script>
<style lang="scss">
.menuAdmin {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        // border-right: 1px #eee solid;
        // padding: 0 20px;
        box-sizing: border-box;
        height: 100%;
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
    .formCont {
        width: calc(100% - 250px);
        padding: 20px;
        border-left: 1px #ddd solid;
        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content {
            width: 500px;
        }
        .el-input {
            max-width: 450px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
        .footer {
            text-align: left;
            margin: 30px 100px;
        }
    }
}
</style>
